import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const ProspectiveLossComponent = (props) => (

    <div>
        <ReportSectionHeader>
			{props.lossType+" Prospective 12-Month Rule 10b-5 Risk (1-Yr. Future Risk)"}
        	
        </ReportSectionHeader>
        <ReportTable
            settings={[
                {
                    header: 'Adverse Corporate Event (ACE) Type',
                    accessor: 'statTypeNum',
                    statType: true
                },
                {
                    header: 'Historical Population Count of ACEs',
                    accessor: 'countOfACE',
                    centerRightJustified: true
                },
                {
                    header: props.lossType+' Market Cap Loss per ACE~(000s)',
                    accessor: 'mcl',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: props.lossType+' Max. Potential Rule 10b-5 Aggregate Damages per ACE~(000s)',
                    accessor: 'damages',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: 'Prospective Potential Rule 10b-5 Settlement Loss by ACE Type~(000s)',
                    accessor: 'loss',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                },
                {
                    header: 'Preceding 12-Month Frequency of Severe ACE',
                    accessor: 'countOfACEPriorYear'
                },
                {
                    header: props.lossType+' Prospective Annual Settlement Loss~(000s)',
                    accessor: 'estimatedLoss',
                    dollarValue: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                    inThousands: true,
                    centerRightJustified: true
                }
            ] 
           }
            data={props.prospectiveLosses}
            name={"prospectiveLosses"}
            accumulator={"estimatedLoss"}
            accumulatorDisplay={props.lossType+" Prospective 12-Month Rule 10b-5 Loss"}
        />

    </div>
);


export default ProspectiveLossComponent;


// WEBPACK FOOTER //
// ./src/common/components/ProspectiveLoss/ProspectiveLossComponent.js